import { UnitsDisplay } from '../../../../common/components/units-display';
import { useEventPanelUnits } from '../../../units/use-event-panel-units';
import { TabSection } from '../../../../panels/entity-panels/tabs/tab-section';
import { EventStaffCountDisplay } from '../../../event-staff-count-display';

export const AssignedSection = () => {
    const pillUnits = useEventPanelUnits();
    return (
        <TabSection title="Assigned">
            <EventStaffCountDisplay eventHasUnits={!!pillUnits.length} />
            {!!pillUnits.length && (
                <UnitsDisplay units={pillUnits} enableContextMenu={true} wrap={true} />
            )}
        </TabSection>
    );
};
